module.exports = __webpack_public_path__ + "static/media/SFPRODISPLAYMEDIUM.51fd7406.OTF";